export default {
  create: {
    success: 'Entité créer avec succès',
    error: "Impossible de créer l'entité"
  },
  update: {
    success: "Modification de l'entité effectué avec succès",
    error: "Impossible mettre à jour l'entité"
  },
  delete: {
    success: 'Entité supprimée avec succès',
    error: "Impossible de supprimer l'entité"
  }
}
